import { Component } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContentComponent } from './session-timeout-content.component';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';


@Component({
	selector: 'app-session-timeout-modal',
	templateUrl: './session-timeout-modal.component.html',
	styleUrls: ['./session-timeout-modal.component.scss']
})
export class SessionTimeoutModalComponent {
	closeResult: string;

	constructor(
		private modalService: NgbModal
		, private router: Router
	) { }

	open(): Observable<string> {
		return new Observable(obs => {
			this.modalService.open(NgbdModalContentComponent).result.then((result) => {
				obs.next(result);
				if (result === 'StayloggedIn') {
					// call stay alive...
					//This is passed to the subscriber and they act on the result calling touch()
					console.log('Modal pushing to keep session alive');
				} else {
					// log out!
					console.log('STMC: Logout now');
					this.router.navigate(['logout/all']);
				}
			}, (reason) => {
				// log out!
				console.log('STMC: Logout now');
				this.router.navigate(['logout/all']);
			});
		});
	}

	// private getDismissReason(reason: any): string {
	// 	if (reason === ModalDismissReasons.ESC) {
	// 		return 'by pressing ESC';
	// 	} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
	// 		return 'by clicking on a backdrop';
	// 	} else {
	// 		return `with: ${reason}`;
	// 	}
	// }

}

